<template>
    <div class="vx-row mb-3">
        <div class="vx-col w-full lg:w-1/1">
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 1 }" 
                @click="$emit('tab-change', 1)"
            >
                리콜Todo
            </vs-button>
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 2 }" 
                @click="$emit('tab-change', 2)"
            >
                신규
            </vs-button>
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 3 }" 
                @click="$emit('tab-change', 3)"
            >
                신규(재)
            </vs-button>
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 4 }" 
                @click="$emit('tab-change', 4)"
            >
                이슈Todo
            </vs-button>
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 5 }" 
                @click="$emit('tab-change', 5)"
            >
                VIP
            </vs-button>
            <vs-button 
                type="line" 
                :class="{ active: activeTab === 6 }" 
                @click="$emit('tab-change', 6)"
            >
                Black
            </vs-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TodoTabNavigation',
    props: {
        activeTab: {
            type: Number,
            default: 1
        }
    },
    emits: ['tab-change']
};
</script>

<style scoped>
.active {
    border-color: #015666;
}
</style>